<template>
  <div class="image-list-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>图片数据列表</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="refreshData">刷新</el-button>
      </div>
      
      <el-table
        :data="imageList"
        v-loading="loading"
        border
        style="width: 100%">
        <el-table-column
          align="center"
          header-align="center"
          label="序号"
          type="index"
          width="50"
          :index="indexMethod">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="id"
          label="ID"
          width="80">
        </el-table-column>
        <el-table-column
          align="center"
          header-align="center"
          prop="name"
          label="图片名称"
          width="260">
        </el-table-column>
        <el-table-column
          prop="url"
          label="图片预览"
          width="120">
          <template slot-scope="scope">
            <el-image
              style="width: 80px; height: 80px"
              :src="scope.row.url"
              :preview-src-list="[scope.row.url]"
              fit="cover">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="size"
          label="文件大小"
          width="120">
          <template slot-scope="scope">
            {{ formatFileSize(scope.row.size) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="文件类型"
          width="120">
        </el-table-column>
        <el-table-column
          prop="uploadTime"
          label="上传时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="description"
          label="描述">
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleView(scope.row)">查看</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { fetchImageList, deleteUploadFile } from '@/api/modules/upload'

export default {
  name: 'ImageList',
  data() {
    return {
      imageList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  created() {
    this.fetchImageData()
  },
  methods: {
    async fetchImageData() {
      this.loading = true
      try {
        const data = await fetchImageList()
        const allImages = data.list || []
        
        // 前端分页处理
        this.total = allImages.length
        const startIndex = (this.currentPage - 1) * this.pageSize
        const endIndex = startIndex + this.pageSize
        this.imageList = allImages.slice(startIndex, endIndex)
      } catch (error) {
        console.error('获取图片数据失败:', error)
        this.imageList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB'
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB'
      }
    },
    handleView(row) {
      this.$alert(`<img src="${row.url}" style="max-width: 100%;">`, row.name, {
        dangerouslyUseHTMLString: true,
        customClass: 'image-preview-dialog'
      })
    },
    async handleDelete(row) {
      this.$confirm(`确定要删除图片 "${row.name}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteUploadFile(row.name)
          this.$toast.success('删除成功')
          this.fetchImageData()
        } catch (error) {
          console.error('删除失败:', error)
        }
      }).catch(() => {
        // 取消删除
      })
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.fetchImageData()
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.fetchImageData()
    },
    refreshData() {
      this.fetchImageData()
    },
    indexMethod(index) {
      return index * 1;
    }
  }
}
</script>

<style scoped>
.image-list-container {
  /* 撑满内容区，滚动下沉到模块内部 */
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--surface-2);
  color: #909399;
  font-size: 24px;
}
</style>

<style>
.image-preview-dialog {
  width: 80%;
  max-width: 800px;
}
</style>
